import { OutsideServiceM8 } from "../../components/OutsideServiceM8";
import { ThemePicker } from "../../components/ThemePicker";
import { Panel } from "../../components/ui";
import { themeLocked } from "../../lib/theme";

/**
 * Your own colour theme (lib/theme.ts): Device, Light or Dark. Inside ServiceM8 on the web the app
 * stays light, but it can still be chosen here (the account menu hides it there), with a link to
 * open the app in a browser where it shows.
 */
export function AppearanceSection() {
    return (
        <Panel title="Theme">
            <div className="space-y-3">
                {/* The choices centred (full width they'd be needlessly big), their caption centred under them; the ServiceM8 note full width. */}
                <div className="mx-auto max-w-xl">
                    <ThemePicker />
                </div>
                {themeLocked ? (
                    <OutsideServiceM8>
                        Inside ServiceM8 on the web the app stays light, to match ServiceM8. Your choice shows when you open the app in your browser, and in
                        ServiceM8&apos;s phone app.
                    </OutsideServiceM8>
                ) : (
                    <p className="m-0 text-center text-muted">Device follows your phone or computer&apos;s own light or dark setting.</p>
                )}
            </div>
        </Panel>
    );
}
